import { render, staticRenderFns } from "./ExpenseForm.vue?vue&type=template&id=0af23f2c&scoped=true"
import script from "./ExpenseForm.vue?vue&type=script&lang=js"
export * from "./ExpenseForm.vue?vue&type=script&lang=js"
import style0 from "./ExpenseForm.vue?vue&type=style&index=0&id=0af23f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af23f2c",
  null
  
)

export default component.exports